<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.gradeImport')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.student.gradeImport')}}</div>
                        <b-button variant="primary" @click="checkSignature" v-if="step == 1" class="float-right">
                            {{$t('button.continue')}}</b-button>
                        <b-button variant="primary" @click="goBack" v-if="step == 2 && isNormalUser"
                            class="float-right">{{$t('button.goBack')}}</b-button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="border border-dark p-2 mb-5">
                                    <a href="/templates/CSV-Sample-GradeImport.csv" class="mb-3 d-block"
                                        download>{{$t('form.import.download')}}</a>

                                    <div class="font-weight-bold">{{$t('form.import.requirement')}}</div>
                                    <ul>
                                        <li>{{$t('form.import.requirement1')}}</li>
                                        <li>{{$t('form.import.requirement2', {format: dateFormat})}}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-7">
                                <b-form-checkbox class="mb-4" v-model="header">
                                    {{$t('form.import.csvHeader')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvHeaderText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="delimiter">
                                    {{$t('form.import.csvDelimiter')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvDelimiterText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="qualifier">
                                    {{$t('form.import.csvQualifier')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvQualifierText')}}</span>
                                </b-form-checkbox>


                                <b-form-checkbox class="mb-4" v-model="updateGrades" v-if="this.permissions.updateImportGrades">
                                    {{$t('form.import.updateGrades')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.updateGradesText')}}</span>
                                </b-form-checkbox>


                                 <b-form-checkbox class="mb-4" v-model="disableGradeNotifications">
                                    {{$t('form.import.disableGradeNotification')}} <br>
                                </b-form-checkbox>


                            </div>

                            <div class="col-md-5">
                                <div class="form-group" v-show="step == 1">
                                    <label>{{$t('form.import.signaturePad')}}</label>
                                    <VueSignaturePad width="400px" height="250px" ref="signaturePad"
                                        :options="{ backgroundColor: '#f6f6f6' }" />
                                    <div class="mt-3">
                                        <!-- <b-button type="button" @click="save">Save</b-button> -->
                                        <b-button type="button" @click="undo">{{$t('button.undo')}}</b-button>
                                        <b-button type="button" @click="clear">{{$t('button.clear')}}</b-button>
                                    </div>
                                </div>

                                <div class="form-group" v-show="step == 2">
                                    <label class="control-label"
                                        for="StatusID:">{{$t('form.student.uploadFile')}}</label>

                                    <vue-dropzone @vdropzone-sending="importingData" ref="myVueDropzone" id="dropzone"
                                        :options="dropzoneOptions" @vdropzone-complete="fileSubmitted"
                                        @vdropzone-processing="isLoading=true">
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    export default {
        props: ['permissions', 'user', 'dateFormat'],
        components: {
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                step: 1,

                dropzoneOptions: {
                    url: `/api/grades/import`,
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                header: true,
                delimiter: true,
                qualifier: false,
                signature: null,
                updateGrades:false,
                disableGradeNotifications:false
            }
        },

        mounted() {
            if (!this.permissions.createImportGrades) {
                return this.$router.push('/');
            }

             let  savedRecordStatus = window.localStorage.getItem('dataSaved');
            if(savedRecordStatus)
            {
                this.showAlert(savedRecordStatus);
                window.localStorage.removeItem('dataSaved');
            }
        },

        watch: {
            isNormalUser(val) {
                if (val) {
                    this.step = 1;
                } else {
                    this.step = 2;
                }
            }
        },

        computed: {
            isNormalUser() {
                if (!this.user.roles) return true;

                let role = this.user.roles.find(r => r.slug == 'admin');

                if (role || this.user.partner_id == 1) {
                    this.step = 2;
                    return false;
                };

                return true;
            }
        },

        methods: {

            importingData(file, xhr, formData) {
                formData.append('heading_row', this.header ? 1 : 0);
                formData.append('delimiter', this.delimiter ? 1 : 0);
                formData.append('qualifier', this.qualifier ? 1 : 0);
                formData.append('signature', this.signature);
                formData.append('updateGrades', this.updateGrades ? 1:0);
            },

            checkSignature() {
                const {
                    isEmpty,
                    data
                } = this.$refs.signaturePad.saveSignature();

                if (isEmpty === true && data === undefined) {
                    alert('Please add signature first.');
                    return;
                }

                // store signature
                this.isLoading = true;

                axios
                    .post('/api/users/signature', {
                        data_uri: data
                    })
                    .then(response => {

                        this.isLoading = false;

                        if (response.data.success) {
                            // fetch updated signature
                            this.signature = response.data.data;
                            this.step = 2;
                            this.clear();
                        } else if (response.data.error) {
                            alert(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        alert(error.response.statusText);
                    });
            },

            goBack() {
                this.step = 1;
            },

            clear() {
                this.$refs.signaturePad.clearSignature();
            },

            undo() {
                this.$refs.signaturePad.undoSignature();
            },

            fileSubmitted(response) {
                this.isLoading = false;

                let data = JSON.parse(response.xhr.response);

                if (response.status == 'success') {

                    localStorage.setItem('grades',JSON.stringify(data.data));
                    localStorage.setItem('path',data.data.path);
                    localStorage.setItem('qualifier',this.qualifier ? 1 : 0);
                    localStorage.setItem('signature',this.signature);
                    localStorage.setItem('updateGrades',this.updateGrades ? 1: 0);
                    localStorage.setItem('disableGradeNotifications',this.disableGradeNotifications ? 1: 0);

                    this.showAlert(data.message);
                    this.$router.push({name: 'GradeImportPreview'});
                } else if (response.status == 'error') {
                    this.showAlert(data.message, 'danger');
                }



            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
